import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Users from "./Pages/Users/User";
import VerifyProfiles from "./Pages/VerifiedProfile/VerifiedProfile";
import Reports from "./Pages/Reports/Reports";
import Login from "./Pages/Registration/Login";
import UserForm from "./Pages/Users/UserFrom";
import MainLayout from "./Pages/MainLayout";
import Notifications from "./Pages/Notifications/Notifications";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import NotificationCreate from "./Pages/Notifications/NotificationCreate";
import Payment from "./Pages/payment/Payment";

const AppRoutes = () => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  console.log("isLoggedIn", isLoggedIn);

  return (
    <Routes>
      {isLoggedIn ? (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <MainLayout>
                <Dashboard />
              </MainLayout>
            }
          />
          <Route
            path="/users"
            element={
              <MainLayout>
                <Users />
              </MainLayout>
            }
          />
          <Route
            path="/verify-profiles"
            element={
              <MainLayout>
                <VerifyProfiles />
              </MainLayout>
            }
          />
          <Route
            path="/reports"
            element={
              <MainLayout>
                <Reports />
              </MainLayout>
            }
          />
          <Route
            path="/user-form"
            element={
              <MainLayout>
                <UserForm />
              </MainLayout>
            }
          />
          <Route
            path="/user-form/:name"
            element={
              <MainLayout>
                <UserForm />
              </MainLayout>
            }
          />
          <Route
            path="/notifications"
            element={
              <MainLayout>
                <Notifications />
              </MainLayout>
            }
          />
          <Route
            path="/notification-create"
            element={
              <MainLayout>
                <NotificationCreate />
              </MainLayout>
            }
          />
          <Route
            path="/payment"
            element={
              <MainLayout>
                <Payment />
              </MainLayout>
            }
          />
        </>
      ) : (
        <>
          <Route path="/" element={<Login />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
